import React, { FunctionComponent } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import {ReactComponent as ExplorerSvg} from "../../../resources/icons/nav_bar/explorer.svg";

type Props = { className?: string }
const icon: FunctionComponent<Props> = (props) => <SvgIcon className={props.className} component={ExplorerSvg} viewBox="-1 -1 22 22"/>;

export default React.memo(icon);
